import { Base, base } from "./base"

export type Shadows = Base

export const shadows: Shadows = {
  ...base,
}
